import React from 'react';
import { Machine, interpret } from 'xstate'; // or use your own interpreter!

export default function useMachine({ machineConfig, machineOptions, initialContext }) {
  const [state, setState] = React.useState();
  const [service] = React.useState(
    interpret(
      Machine(
        { ...machineConfig, context: { ...machineConfig.context, ...initialContext } },
        machineOptions,
      ),
    ),
  );
  !service.initialized &&
    service
      .onTransition(state => {
        console.log('val', state, state.value);
        setState(state);
      })
      .start();

  return { service, state };
}
